import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JeevesOrderService } from 'gung-standard-jeeves';
import { CustomerService, Order } from 'gung-standard';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ColmecOrderService extends JeevesOrderService {
  private httpClient: HttpClient;
  private quotes: BehaviorSubject<Order[]>;
  private quoteObservable: Observable<Order[]>;

  constructor(http: HttpClient, customerService: CustomerService) {
    super(http, customerService);
    this.httpClient = http;
    this.getQuotes(true).subscribe(v => {
      this.quotes = new BehaviorSubject<Order[]>(v);
      this.quoteObservable = this.quotes.asObservable();
    });
  }

  getOpenOrders(nocache?: boolean): Observable<Order[]> {
    const url = `json/colmec/open-orders`;
    const headers = {
      maxAge: nocache ? '-1' : '60'
    };
    return this.httpClient.get<Order[]>(url, { headers });
  }

  getQuotes(nocache?: boolean): Observable<Order[]> {
    const url = `json/quotes`;
    const headers = {
      maxAge: nocache ? '-1' : '60'
    };
    return this.httpClient.get<Order[]>(url, { headers });
  }

  updateQuotesSubject(): void {
    this.getQuotes(true).subscribe(d => this.quotes.next(d));
  }

  getQuotesFromSubject(): Observable<Order[]> {
    return this.quoteObservable;
  }

  postAddRowToOrder(orderId: string, row: any): Observable<Order> {
    const url = `json/order/${orderId}/row`;
    return this.httpClient.post<Order>(url, row);
  }
}
